import { Box, Typography } from "@mui/material";
import { formatLabel } from "@/utils/format-label";
import { KycActionsPopover } from "./kyc-actions-popover";

export const getKycColumns = (onEditClick) => [
  {
    accessorKey: "merchantId",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>
        Merchant ID
      </div>
    ),
    cell: ({ row }) => (
      <Typography
        fontSize="0.85rem"
        fontWeight={500}
        fontFamily="monospace"
      >
        {row.original.merchantId ?? "N/A"}
      </Typography>
    ),
  },

  {
    accessorKey: "businessName",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>
        Business Name
      </div>
    ),
    cell: ({ row }) => (
      <div>
        <div
          style={{
            fontSize: "0.85rem",
            whiteSpace: "nowrap",
            fontWeight: 500,
          }}
        >
          {row.original.businessName ?? "N/A"}
        </div>

        <div
          style={{
            fontSize: "0.75rem",
            color: "#6b7280",
            marginTop: 2,
          }}
        >
          {row.original.businessEmail ?? "N/A"}
        </div>
      </div>
    ),
  },

  {
    accessorKey: "businessType",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>
        Business Type
      </div>
    ),
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {formatLabel(row.original.businessType) ?? "N/A"}
      </Typography>
    ),
  },

  {
    accessorKey: "businessIndustry.name",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>
        Industry
      </div>
    ),
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.businessIndustry?.name ?? "N/A"}
      </Typography>
    ),
  },

  {
    accessorKey: "approvalStatus",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>
        Approval Status
      </div>
    ),
    cell: ({ row }) => {
      const status = row.original.approvalStatus;

      const colorMap = {
        APPROVED: {
          bg: "#ecfdf5",
          text: "#065f46",
          dot: "#10b981",
        },
        PENDING: {
          bg: "#fffbeb",
          text: "#92400e",
          dot: "#f59e0b",
        },
        REJECTED: {
          bg: "#fef2f2",
          text: "#991b1b",
          dot: "#ef4444",
        },
      };

      const style = colorMap[status] || {
        bg: "#f3f4f6",
        text: "#374151",
        dot: "#9ca3af",
      };

      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 1.5,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: style.bg,
            color: style.text,
            fontSize: "0.78rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: style.dot,
            }}
          />

          {formatLabel(status ?? "UNKNOWN")}
        </Box>
      );
    },
  },

  {
    accessorKey: "createdAt",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>
        Created At
      </div>
    ),
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.createdAt
          ? new Date(row.original.createdAt).toLocaleString()
          : "N/A"}
      </Typography>
    ),
  },

  {
    id: "actions",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>
        Action
      </div>
    ),
    cell: ({ row }) => (
      <KycActionsPopover
        kyc={row.original}
        onEditClick={onEditClick}
      />
    ),
  },
];